import { render } from "./Loading.vue?vue&type=template&id=63751082&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=63751082&scoped=true&lang=css"

import exportComponent from "D:\\Abdulahad\\Front end\\template\\plovcenter\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63751082"]])

export default __exports__